import styled from 'styled-components';

import STANDARDDEFAULTSRC from 'assets/logo-tsl.svg';
import buildLogo from 'components/b2b/Logo';
import ColormapInterface from 'shared-types/colormapinterface';
import { borderRadius, colorFilterUsage, fontSize, fontWeight, letterSpacing } from 'stylesheetB2b';
import { getSpacing } from 'stylesheetB2c';
import { ALLEXTENSIONS, getLogoModel, STANDARDLOGOKEY } from 'types/logo/logo';
const logoModel = getLogoModel(STANDARDLOGOKEY, ALLEXTENSIONS, STANDARDDEFAULTSRC);

const TslLogoImg = buildLogo(logoModel);

export const DesktopPlayerContentWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-bottom: ${getSpacing(14)};
`;

export const PlayerLauncherButton = styled.button<{ colors: ColormapInterface }>`
  height: ${getSpacing(12)};
  width: ${getSpacing(56)};
  background: ${({ colors }) => colors.desktopPlayerLauncherButtonBackground};
  border: none;
  color: ${({ colors }) => colors.appBackground};
  border-radius: ${borderRadius.XXXLarge};
  padding: ${getSpacing(3)} 0;
  text-align: center;
  font-size: ${fontSize.mediumLarge};
  letter-spacing: ${letterSpacing.double};
  font-weight: ${fontWeight.bold};
`;

export const LauncherLogo = styled(TslLogoImg)`
  height: ${getSpacing(16)};
  margin-bottom: ${getSpacing(16)};
  filter: ${colorFilterUsage.tslLogo};
`;
